﻿import { offersCollapsible } from './offers-collapsible';
import { DropdownOption } from './offers-dropdownOption';

export const specialOffersDropdown = function (dropdown, onOptionSelected) {
    const filterKey = dropdown.getAttribute("data-filter-Key");
    const fullFilterList = [];
    const dropDownList = dropdown.querySelector('.dropdown__options');
    const dropDownListItems = Array.prototype.slice.call(dropdown.querySelectorAll('.dropdown__options li'))
    const isOwner = filterKey === null;
    const inputField = dropdown.querySelector(".dropdown__selection");
    const readOptionsListIntoArray = () => {
        dropDownListItems.map((item) => {
            fullFilterList.push({
                "item": item.textContent.trim(),
                "filterKey": item.getAttribute(filterKey),
            });
        });
    };
    const createOptionListItem = ({ item = '' }) => `<li class="dropdown__option"><span class="dropdown__option--text">${item}</span></li>`;
    const getFilterString = (input, isOwnerSelection) => (isOwnerSelection ? input.filterKey.trim() : input.item) || '';
    const generateOptionsList = (input, isOwnerSelection) => {
        dropDownList.innerHTML = '';
        const currentList = fullFilterList.filter(option => {
            const item = getFilterString(option, isOwnerSelection);
            const itemString = `${item}`.toLowerCase();
            return itemString.includes(input.trim().toLowerCase());
        });
        addOptionsToList(currentList);
    };
    const addOptionsToList = currentList => {
        for (let index = 0; index < currentList.length; index++) {
            dropDownList.innerHTML += createOptionListItem(currentList[index]);
        }
    }
    const handleOptionClick = (e) => {
        const optionNode = e.target.closest(DropdownOption.selectors.root);
        const filterInput = dropdown.getElementsByTagName('span')[1];
        if (filterInput && optionNode) {
            filterInput.value = optionNode.attributes['data-value'].value;
            filterInput.textContent = optionNode.innerText.trim();
            document.getElementById('SelectedSortOptionValue').value = optionNode.attributes['data-value'].value;
        }
        if (optionNode) {
            selectOption(optionNode, e);
        }
    }
    function onCollapsibleToggled(e) {
        if (e.isOpen) {
            dropdown.addEventListener("click", handleOptionClick);
        } else {
            dropdown.removeEventListener("click", handleOptionClick);
        }
    }
    const collapsible = offersCollapsible(dropdown, onCollapsibleToggled);
    const options = [...dropdown.querySelectorAll(DropdownOption.selectors.root)]
        .map(opt => DropdownOption(opt));
    const selectOption = (option, event) => {
        const optionToSelect = options.find(o => o.elem.innerText.trim() === option.innerText.trim());
        const selectedOption = getSelectedOption();
        if (selectedOption) {
            selectedOption.deselect();
        }
        optionToSelect.select();
        if (typeof onOptionSelected === "function") {
            onOptionSelected(optionToSelect, event, isOwner);
        }
        close();
    }
    const getSelectedOption = () => {
        const selectedOptions = options.filter(option => option.isSelected());
        return selectedOptions.length > 0 ? selectedOptions[0] : null;
    }
    const hasSelection = () => {
        return getSelectedOption() !== null;
    }
    const close = () => {
        collapsible.close();
    }
    const filter = (optionSelected) => {
        generateOptionsList(optionSelected, true);
    }
    const init = () => {
        readOptionsListIntoArray();
        const filterInput = dropdown.getElementsByTagName('span')[1];
        const initialOptionToSelect = options.find(o => o.elem.innerText.trim() === filterInput.innerText.trim());
        initialOptionToSelect.select();
    };
    init();
    return {
        elem: dropdown,
        options,
        hasSelection,
        close,
        filter,
        isOwner,
        inputField,
        getSelectedOption
    };
};
specialOffersDropdown.selectors = {
    root: "[data-component='offers-dropdown']"
};